import { Pause, Play, CheckCircle, Clock, Loader } from "lucide-react";
import { useNavigate } from "react-router-dom";

const TaskHistory = ({ history }) => {
    const navigate = useNavigate();
    const safeHistory = Array.isArray(history) ? history : [];

    const formatTimestamp = (timestamp) => {
        const date = new Date(timestamp);
        return date.toLocaleString("en-US", {
            year: "numeric",
            month: "short",
            day: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: false,
        });
    };

    const getIcon = (event) => {
        switch (event) {
            case "pause":
                return <Pause size={14} className="text-warning" />;
            case "play":
                return <Play size={14} className="text-success" />;
            case "completed":
                return <CheckCircle size={14} className="text-primary" />;
            case "inprogress":
                return <Loader size={14} className="text-info animate-spin" />;
            default:
                return <Clock size={14} className="text-ink-muted" />;
        }
    };

    const resolveEvent = (title) => {
        if (title === "Completed") return "completed";
        if (title === "Paused") return "pause";
        if (title === "Continue Task" || title === "Open") return "play";
        if (title === "In Progress") return "inprogress";
        return "default";
    };

    const sortedHistory = [...safeHistory]
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
        .slice(0, 10);

    return (
        <div className="task-history">
            <div className="task-history__header">
                <h3 className="text-sm font-semibold text-ink">Task History</h3>
                <button
                    type="button"
                    className="task-history__link"
                    onClick={() =>
                        navigate("/history", { state: { history: safeHistory } })
                    }
                >
                    View History
                </button>
            </div>

            {sortedHistory.length === 0 ? (
                <p className="text-xs text-ink-muted italic">No history available</p>
            ) : (
                <div className="space-y-2">
                    {sortedHistory.map((entry, index) => (
                        <div key={index} className="task-history__entry">
                            <div className="mt-0.5 shrink-0">
                                {getIcon(resolveEvent(entry.title))}
                            </div>
                            <div className="flex flex-col leading-tight w-full min-w-0">
                                <p className="font-medium text-ink">{entry.title}</p>
                                <p className="text-ink-muted">
                                    {formatTimestamp(entry.createdAt)}
                                </p>
                                {entry.notes && (
                                    <p className="text-ink-secondary italic">
                                        Reason: {entry.notes}
                                    </p>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default TaskHistory;
